export default __webpack_public_path__ + "static/media/map_location.32ba9971.jpg";